import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import { Outlet } from 'react-router-dom';


const UserLayout = () => {
  return (
    <>
    {/* Header */}
    <Header className="bg-black" />

    {/* Main Content */}
    <main className="pt-[150px]">

      <Outlet />
      
    </main>

    {/* Footer */}
    <Footer />
    </>
  );
};

export default UserLayout;
